
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  $getSelection,
  $isRangeSelection,
  COMMAND_PRIORITY_CRITICAL,
  KEY_ENTER_COMMAND,
} from 'lexical';
import { useEffect } from 'react';
import { $isWhatsAppCodeBlockNode } from '../nodes';

export function WhatsAppCodeBlockPlugin(): null {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      KEY_ENTER_COMMAND,
      (event: KeyboardEvent | null) => {
        const selection = $getSelection();
        if (!$isRangeSelection(selection)) {
          return false;
        }

        const anchorNode = selection.anchor.getNode();
        
        // Traverse up to find if we are inside a code block
        let currentNode = anchorNode;
        let isCodeBlock = false;
        
        while (currentNode) {
            if ($isWhatsAppCodeBlockNode(currentNode)) {
                isCodeBlock = true;
                break;
            }
            if (currentNode.getType() === 'root') break;
            const parent = currentNode.getParent();
            if (!parent) break;
            currentNode = parent;
        }

        if (isCodeBlock) {
          // If in code block, Enter should just insert newline
          selection.insertText('\n');
          return true; // Stop propagation
        }

        return false;
      },
      COMMAND_PRIORITY_CRITICAL
    );
  }, [editor]);

  return null;
}
